import { FOOTER } from "@/constants/testIds";

const LOGO_URL =
  "https://static.prod-images.emergentagent.com/jobs/c137c95c-c864-4200-a8d8-aee5a7faa3c6/images/472fddcb8285fa21163045202d4de154e8d7e5fe5359ee0567a9994613ff0b5c.jpeg";

export default function Footer() {
  return (
    <footer
      data-testid={FOOTER.section}
      className="border-t border-border/70 px-6 md:px-10 py-12 max-w-7xl mx-auto"
    >
      <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
        <div data-testid={FOOTER.logo} className="flex items-center gap-2.5">
          <img src={LOGO_URL} alt="Pulse Agentic" className="h-6 w-6 rounded-md" />
          <span className="font-display text-sm text-ink">Pulse Agentic Private Limited</span>
        </div>
        <p className="text-xs text-muted-foreground">
          © {new Date().getFullYear()} Pulse Agentic Private Limited. Strategy, Tech & Product — as one.
        </p>
      </div>
    </footer>
  );
}
